






















































































import moment from "moment";
import Modal from "../core/Modals/Modal.vue";
import PhotosViewer from "../core/Files/PhotosViewer.vue";
import { ControleVehiculeApi } from "../api/ControleVehiculeApi";
import ConfirmSuppression from "../core/Modals/ConfirmSuppression";

// Libellés FR des vues obligatoires (cf. ControleVehicule::MANDATORY_PHOTOS).
const PHOTO_TYPE_LABELS = {
    front: "Avant",
    rear: "Arrière",
    left: "Côté gauche",
    right: "Côté droit",
    odometer: "Compteur km",
};

// Libellés FR des valeurs brutes d'un défaut (defaut|sale|manquant|a_signaler).
const VALEUR_LABELS = {
    defaut: "Défaut",
    sale: "Sale",
    manquant: "Manquant",
    a_signaler: "À signaler",
};

export default {
    name: "ControleDetailModal",
    components: { Modal, PhotosViewer },
    props: {
        showModal: Boolean,
        controle: Object,
    },
    data() {
        return {
            api: new ControleVehiculeApi(),
        };
    },
    computed: {
        formattedDate() {
            if (!this.controle || !this.controle.date_controle) {
                return "";
            }
            return moment(this.controle.date_controle, "YYYY-MM-DD").format(
                "DD/MM/YYYY"
            );
        },
        photos() {
            if (!this.controle) {
                return [];
            }

            // Vues obligatoires, légendées par leur type (Avant, Arrière, ...).
            const mandatory = (this.controle.photos || []).map((p) => ({
                ...p,
                caption: PHOTO_TYPE_LABELS[p.type] || p.type || "Photo",
            }));

            // Photos rattachées aux défauts, légendées par le défaut concerné
            // (ex. « Pneumatiques — Usé »).
            const defectPhotos = [];
            (this.controle.defauts || []).forEach((d) => {
                const label = [d.label || d.point_code, this.valeurLabel(d.valeur)]
                    .filter(Boolean)
                    .join(" — ");
                (d.photos || []).forEach((p) => {
                    defectPhotos.push({ ...p, caption: label || "Défaut" });
                });
            });

            return [...mandatory, ...defectPhotos];
        },
    },
    methods: {
        priorityLabel(priority) {
            const labels = {
                high: "Élevée",
                normal: "Normale",
            };
            return labels[priority] || priority;
        },
        valeurLabel(valeur) {
            if (!valeur) {
                return "";
            }
            return VALEUR_LABELS[String(valeur).toLowerCase()] || valeur;
        },
        openPdf() {
            this.api.openInNewTab(this.api.pdfUrl(this.controle.id));
        },
        deleteControle() {
            let self = this;
            ConfirmSuppression.demanderRaison(
                "Voulez-vous supprimer ce contrôle ?"
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.api
                    .delete(self.controle.id, raison)
                    .then(() => {
                        self.$emit("controle-deleted");
                    })
                    .catch(() => {
                        swal(
                            "Le contrôle n'a pas pu être supprimé.",
                            "",
                            "error"
                        );
                    });
            });
        },
        close() {
            this.$emit("close-modal");
        },
    },
};
